// Langue de la vitrine (INTL-04) : sélecteur de l'en-tête (snippet fs-lang-switcher), seul moyen de changer de langue
// (aucun bandeau de suggestion ni redirection selon le navigateur : demande de Charles du 11 octobre 2026).
// <details> utilisable sans script ; ici, la chaîne de requête et l'ancre suivent la langue choisie (?game=,
// #fs-catalog), Échap et le clic ailleurs referment avec le focus rendu au bouton, les flèches parcourent les langues.

/** Adresse d'une langue avec la requête et l'ancre de la page courante (même page, autre préfixe). */
export function withState(href, location) {
  try {
    const url = new URL(href, location.href);
    url.search = location.search;
    url.hash = location.hash;
    return url.pathname + url.search + url.hash;
  } catch {
    return href;
  }
}

function enhanceSwitcher(details, win) {
  const doc = details.ownerDocument;
  const summary = details.querySelector('[data-fs-lang-toggle]');
  const options = [...details.querySelectorAll('[data-fs-lang-option]')];
  const close = (focus) => {
    if (!details.open) return;
    details.open = false;
    if (focus) summary.focus();
  };
  // Liens à jour à l'ouverture et au clic (l'adresse change sans rechargement : écran d'un jeu, filtres, ancres).
  const sync = () => options.forEach((link) => { link.href = withState(link.getAttribute('data-fs-lang-href') || link.getAttribute('href'), win.location); });
  options.forEach((link) => link.setAttribute('data-fs-lang-href', link.getAttribute('href')));
  details.addEventListener('toggle', () => { if (details.open) sync(); });
  details.addEventListener('click', (event) => { if (event.target.closest?.('[data-fs-lang-option]')) sync(); });
  details.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && details.open) {
      // Le menu de l'en-tête (for-sale.js, fs-listing-page.js) se fermerait aussi : seul le sélecteur se referme ici.
      event.stopPropagation();
      close(true);
      return;
    }
    const at = options.indexOf(doc.activeElement);
    const move = { ArrowDown: 1, ArrowUp: -1 }[event.key];
    if (move && details.open) {
      event.preventDefault();
      const next = at === -1 ? (move > 0 ? 0 : options.length - 1) : (at + move + options.length) % options.length;
      options[next]?.focus();
    } else if ((event.key === 'Home' || event.key === 'End') && at !== -1) {
      event.preventDefault();
      options[event.key === 'Home' ? 0 : options.length - 1].focus();
    } else if (event.key === 'ArrowDown' && doc.activeElement === summary && !details.open) {
      event.preventDefault();
      details.open = true;
      sync();
      options[0]?.focus();
    }
  });
  doc.addEventListener('click', (event) => { if (!details.contains(event.target)) close(false); });
  details.addEventListener('focusout', (event) => { if (event.relatedTarget && !details.contains(event.relatedTarget)) close(false); });
}

if (typeof document !== 'undefined') {
  const details = document.querySelector('[data-fs-lang]');
  if (details && !details.hasAttribute('data-fs-lang-ready')) {
    details.setAttribute('data-fs-lang-ready', '');
    enhanceSwitcher(details, window);
  }
}
